import { render, staticRenderFns } from "./GLYF_PainSpot_Mgmt.vue?vue&type=template&id=140f9c02&scoped=true"
import script from "./GLYF_PainSpot_Mgmt.vue?vue&type=script&lang=js"
export * from "./GLYF_PainSpot_Mgmt.vue?vue&type=script&lang=js"
import style0 from "./GLYF_PainSpot_Mgmt.vue?vue&type=style&index=0&id=140f9c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140f9c02",
  null
  
)

export default component.exports